import React, { useState } from "react";
import apiClient from "@/services";
import { Button } from "./ui/button";
import { useNavigate } from "react-router-dom";
import { handleRequest, archiveRequest } from "@/scripts/manageRequest";

function ProductAction({ user, item }) {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);

  const handleClick = async (action, requestId) => {
    try {
      setLoading(true);

      const endpoint =
        user.role === "buyer_agent"
          ? "manageBuyerRequest"
          : "manageSellerRequest";

      const { status } = await apiClient.post(`/${endpoint}`, {
        action,
        requestId,
      });

      if (status === 200) {
        navigate(-1);
      }
    } catch (error) {
      setLoading(false);
      console.error("Error updating data:", error);
    }
  };

  const updateStatus = async (item, status) => {
    try {
      setLoading(true);
      // Determine the collection name
      const collection =
        item.type === "buyer_request" ? "buyer_requests" : "seller_requests";

      // Perform the request handling logic
      await handleRequest(collection, item.request_id, status);
      // Go back after action
      navigate(-1);

      console.log("Status updated successfully.");
    } catch (error) {
      console.error("Error updating status:", error);
      alert("Failed to update status. Please try again later.");
    } finally {
      setLoading(false);
    }
  };

  const handleArchive = async (item) => {
    try {
      setLoading(true);
      // Determine the collection name
      const collection =
        item.type === "buyer_request" ? "buyer_requests" : "seller_requests";

      // Perform the request handling logic
      await archiveRequest(collection, item.request_id);
      // Go back after action
      navigate(-1);

      console.log("Status archived successfully.");
    } catch (error) {
      console.error("Error archiving request:", error);
      alert("Failed to archive request. Please try again later.");
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="flex justify-center items-center">
        <div className="animate-spin rounded-full h-10 w-10 border-t-2 border-green"></div>
      </div>
    );
  }

  // if (user.role === "buyer") {
  //   return (
  //     <div className="text-right">
  //       <Button type="submit" className="w-[200px] bg-green mobileInputWrapper">
  //         I'm Interested
  //       </Button>
  //     </div>
  //   );
  // }

  if (user.role === "seller_agent" || user.role === "buyer_agent") {
    return (
      <div>
        <div className="my-4">
          <h1 className="text-sm font-bold text-green ml-0.5">
            Product Actions
          </h1>
          <div className="highlight highlight-lg" />
        </div>

        <div className="flex flex-wrap items-center gap-4 md:gap-6">
          <Button
            className="w-full md:w-[200px] bg-green"
            disabled={item?.status === "approved"}
            onClick={() => handleClick("approve", item.request_id)}
          >
            Approve
          </Button>

          <Button
            className="w-full md:w-[200px] bg-[#e03939]"
            disabled={item?.status === "rejected"}
            onClick={() => handleClick("reject", item.request_id)}
          >
            Reject
          </Button>

          <Button
            className="w-full md:w-[200px] bg-[#ff9720]"
            disabled={item?.status === "escalated"}
            onClick={() => handleClick("escalate", item.request_id)}
          >
            Escalate
          </Button>
        </div>
      </div>
    );
  }

  if (user.role === "admin") {
    return (
      <div>
        <div className="my-4">
          <h1 className="text-sm font-bold text-green ml-0.5">
            Product Actions
          </h1>
          <div className="highlight highlight-lg" />
        </div>

        <div className="flex flex-wrap items-center gap-4 md:gap-6">
          <Button
            className="w-full md:w-[200px] bg-green"
            disabled={item?.status === "approved"}
            onClick={() => updateStatus(item, "approved")}
          >
            Approve
          </Button>

          <Button
            className="w-full md:w-[200px] bg-[#e03939]"
            disabled={item?.status === "rejected"}
            onClick={() => updateStatus(item, "rejected")}
          >
            Reject
          </Button>

          <Button
            className="w-full md:w-[200px] bg-[#ff9720]"
            disabled={item?.status === "escalated"}
            onClick={() => updateStatus(item, "escalated")}
          >
            Escalate
          </Button>

          <Button
            className="w-full md:w-[200px]"
            onClick={() => handleArchive(item)}
          >
            {/* <EyeClosedIcon className="h-6 w-6" /> */}
            Archive
          </Button>
        </div>
      </div>
    );
  }

  return null;
}

export default ProductAction;
